import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_TECHNOLOGIES } from "app/pages/sales-intelligence/constants/routes";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { CardErrorBoundary } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/CardErrorBoundary/CardErrorBoundary";

import TechnologiesCard from "./TechnologiesCard";

const TechnologiesCardWithErrorBoundary = () => (
    <CardErrorBoundary
        dataAutomation="technologies-card"
        header={
            <CardHeader
                title={translate("si.company-analysis.technologies.card.header")}
                infoTooltip={translate("si.company-analysis.technologies.card.header.info-tooltip")}
            />
        }
        footer={<CardFooter stateId={COMPANY_ANALYSIS_TECHNOLOGIES} />}
        width="50%"
    >
        <TechnologiesCard />
    </CardErrorBoundary>
);

export default TechnologiesCardWithErrorBoundary;
